import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  UpdateTenderContractDurationMutation,
  UpdateTenderContractDurationMutationVariables,
  UpdateTenderContractDurationDocument,
} from "@/graphql/__generated__/graphql";

export default function useUpdateTenderContractDurationMutationHook(
  options?: { disableToast?: boolean }
): { updateTenderContractDurationMutation: any; loading: any; error: any } {
  const { t } = useTranslation(["toasts"]);

  const [updateTenderContractDurationMutation, { loading, error }] = useMutation<UpdateTenderContractDurationMutation, UpdateTenderContractDurationMutationVariables>(
    UpdateTenderContractDurationDocument, {
      onCompleted() {
        if (!options?.disableToast) {
          toast(CustomToastComponent, {
            toastId: "contract-duration-updated-success",
            data: {
              title: t("toasts.contractdurationupdated"),
              type: "success",
            },
          });
        }
      },
      update(cache, { data }) {
        if (!data?.updateTenderContractDuration) return;

        const { startDate, endDate } = data.updateTenderContractDuration.contract;
        const tenderId = data.updateTenderContractDuration.id;

        cache.modify({
          id: cache.identify({ __typename: "Tender", id: tenderId }),
          fields: {
            contract(existingContract = {}) {
              return {
                ...existingContract,
                startDate,
                endDate,
              };
            },
          },
        });
      },
    });

  return {
    updateTenderContractDurationMutation,
    loading,
    error,
  };
}
